import React from 'react';
import Skeleton from '@mui/material/Skeleton';

export function ReferralDataSkeleton() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '1rem',
        marginTop: '2.5rem',
      }}
      className="qlf-skeleton"
    >
      <Skeleton variant="rectangular" width="7rem" height="3rem" style={{ borderRadius: 20 }} />
    </div>
  );
}
